export var BACKGROUND_LIGHT = '#F8F9FC';
export var BACKGROUND_DARK = '#142d3b';
export var ACCENT_BLUE = 'rgba(112, 155, 175, 1)';
export var LIGHT_BLUE = '#9DC3CC';
export var LIGHT_BLUE4 = '#2592bd';
export var VERY_LIGHT_BLUE = '#f1fbff';
export var LIGHT_BLUE5 = '#B2D0DE';
export var LIGHT_BLUE6 = '#BBD8FF';
export var LIGHT_BLUE7 = '#3CA1FF';
export var ONBOARDING_BLUE = '#046FFF';
export var ONBOARDING_BLUE2 = '#BBD8FF';
export var MID_BLUE = '#709BAF';
export var MID_BLUE2 = '#0056C4';
export var MID_BLUE3 = '#2e6077';
export var MID_BLUE4 = '#264353';
export var WHITE = '#fff';
export var OFF_WHITE4 = '#e5eff5';
export var OFF_WHITE = '#F8F9FC';
export var OFF_WHITE3 = '#e9f1f7';
export var NAVY = '#1E3C4D';
export var NAVY3 = '#142D3B';
export var NAVY4 = '#193140';
export var NAVY5 = '#21465F';
export var NAVY8 = '#163c4e';
export var NAVY9 = '#24485c';
export var NAVY12 = '#253B4B';
export var NAVY13 = '#344A5A';
export var NAVY14 = '#1A2C3A';
export var NAVY15 = '#264B5D';
export var DARK_NAVY = 'rgb(24, 35, 40)';
export var DARK_NAVY4 = '#1F303F';
export var DARK_NAVY5 = '#172024';
export var DARK_NAVY6 = '#33373E';
export var DARK_NAVY7 = '#264B5D';
export var DARK_GRAY = '#555555';
export var LIGHT_GRAY = '#fafafa';
export var LIGHT_GRAY2 = '#D7E0EA';
export var GRAY = '#9FA19E';
export var GREY1 = '#E5E5E5';
export var GREY2 = '#ccc';
export var GREY3 = '#EAEDF0';
export var GREY4 = '#D7E0EA';
export var GREY5 = '#e2e2e2';
export var GREY6 = '#707070';
export var GREY7 = '#C4C4C4';
export var GREY8 = '#6D7175';
export var GREY9 = '#ddd';
export var GREY10 = '#3c3c3c';
export var GREY11 = '#8D97AC';
export var GREEN_PRIMARY = '#05B078';
export var GREEN_SECONDARY = '#ACDBCC';
export var GREEN1 = '#C4DA6D';
export var GREEN2 = '#30AF1C';
export var GREEN3 = '#039464';
export var BABY_BLUE_PRIMARY = '#A3C2D2';
export var BABY_BLUE_SECONDARY = '#C5D1D7';
export var BABY_BLUE3 = '#BDD3DF';
export var LIGHT_RED = '#F3425A';
export var LIGHT_RED2 = '#D06F6E';
export var RED1 = '#FC3216';
export var RED2 = '#b15e5d';
export var ORANGE1 = '#F4673A';
export var ORANGE2 = '#FF823B';
export var ORANGE3 = '#FF533B';
export var YELLOW1 = '#FFDD87';
export var YELLOW2 = '#FFC83B';
export var YELLOW3 = '#FDF6B7';
export var INNOVATION_PRIMARY = '#d482bd';
export var ALTRUISM_PRIMARY = '#59be71';
export var AUTONOMY_PRIMARY = '#54c4c3';
export var SECURITY_PRIMARY = '#f7b844';
export var PROGRESS_PRIMARY = '#ef6d45';
export var STATUS_PRIMARY = '#c0c0c0';
export var FINANCIAL_NEEDS_PRIMARY = '#d2a952';
export var COMPETITION_PRIMARY = '#DA5957';
export var FEEDBACK_PRIMARY = '#7FB15B';
export var RATIONALITY_PRIMARY = '#408BC9';
export var SOCIAL_RELATIONSHIPS_PRIMARY = '#EC619F';
export var INNOVATION_SECONDARY = '#9F4486';
export var ALTRUISM_SECONDARY = '#2C653B';
export var AUTONOMY_SECONDARY = '#3B8E8D';
export var SECURITY_SECONDARY = '#946F1A';
export var PROGRESS_SECONDARY = '#9D5846';
export var STATUS_SECONDARY = '#888888';
export var FINANCIAL_NEEDS_SECONDARY = '#946F1A';
export var COMPETITION_SECONDARY = '#903636';
export var FEEDBACK_SECONDARY = '#547E36';
export var RATIONALITY_SECONDARY = '#285D87';
export var SOCIAL_RELATIONSHIPS_SECONDARY = '#9C3863';
export var MOTIVATOR_COLORS = {
  INNOVATION_PRIMARY: INNOVATION_PRIMARY,
  ALTRUISM_PRIMARY: ALTRUISM_PRIMARY,
  AUTONOMY_PRIMARY: AUTONOMY_PRIMARY,
  SECURITY_PRIMARY: SECURITY_PRIMARY,
  PROGRESS_PRIMARY: PROGRESS_PRIMARY,
  STATUS_PRIMARY: STATUS_PRIMARY,
  FINANCIAL_NEEDS_PRIMARY: FINANCIAL_NEEDS_PRIMARY,
  COMPETITION_PRIMARY: COMPETITION_PRIMARY,
  FEEDBACK_PRIMARY: FEEDBACK_PRIMARY,
  RATIONALITY_PRIMARY: RATIONALITY_PRIMARY,
  SOCIAL_RELATIONSHIPS_PRIMARY: SOCIAL_RELATIONSHIPS_PRIMARY,
  INNOVATION_SECONDARY: INNOVATION_SECONDARY,
  ALTRUISM_SECONDARY: ALTRUISM_SECONDARY,
  AUTONOMY_SECONDARY: AUTONOMY_SECONDARY,
  SECURITY_SECONDARY: SECURITY_SECONDARY,
  PROGRESS_SECONDARY: PROGRESS_SECONDARY,
  STATUS_SECONDARY: STATUS_SECONDARY,
  FINANCIAL_NEEDS_SECONDARY: FINANCIAL_NEEDS_SECONDARY,
  COMPETITION_SECONDARY: COMPETITION_SECONDARY,
  FEEDBACK_SECONDARY: FEEDBACK_SECONDARY,
  RATIONALITY_SECONDARY: RATIONALITY_SECONDARY,
  SOCIAL_RELATIONSHIPS_SECONDARY: SOCIAL_RELATIONSHIPS_SECONDARY
};
export var BROADER_CULTURE_COLOR_DARK = 'rgba(27, 68, 93, 0.7)';
export var BROADER_CULTURE_COLOR_LIGHT = 'rgba(4, 179, 255, 0.6)';
export var CORE_CULTURE_COLOR_DARK = 'rgba(31, 114, 162, 0.7)';
export var CORE_CULTURE_COLOR_LIGHT = 'rgba(0, 55, 195, 0.6)';
export var MEDIAN_COLOR_DARK = 'white';
export var MEDIAN_COLOR_LIGHT = '#FB6320';
export var GRADIENT1 = '#FFCBCB';
export var GRADIENT2 = '#FFFBD4';
export var TRANSPARENT = 'transparent';